export default __webpack_public_path__ + "static/media/placeholdercar4.8641a02e.png";